import CarbonVue3 from "@carbon/vue";

const carbonPlugin = {
  install(app) {
    app.use(CarbonVue3);
  },
};

export default carbonPlugin;
